import lazyLoad from './lazy-load.js';

class Tabs {
	#container;
	#fetchMethod;
	#elements = [];
	#loading = false;

	constructor(container, fetchMethod) {
		if (container instanceof jQuery) {
			container = container[0];
		}

		this.#container = container;
		this.#fetchMethod = fetchMethod;

		this.#init();
	}

	#init() {
		const tabs = this.#container.matches('.tabs-nav') ?
			[ this.#container ] :
			Array.from(this.#container.querySelectorAll('.tabs-nav'));

		for (const el of tabs) {
			this.initTabs(el);
		}
	}

	initTabs(el) {
		const nav = el.children[0];

		const content = document.querySelector(el.dataset.target);

		const tabs = { el, nav, content };

		tabs.activeLink = nav.querySelector(':scope  > .active');
		tabs.activeContent = content.querySelector(':scope > .active');

		nav.addEventListener('click', async e => {
			e.preventDefault();
			
			if (this.#loading) {
				return;
			}

			const { target } = e;

			if (target.classList.contains('active')) {
				return;
			}

			const li = target.matches('li') ? target : target.closest('li');

			if (!li) {
				return;
			}

			const index = Array.from(nav.children).indexOf(li);
			const newContent = content.children.item(index);
			
			if (this.#fetchMethod && !newContent.dataset.loaded) {
				this.#loading = true;
				
				try {
					const html = await this.#fetchMethod({ tab: li.dataset.tab });
					
					if (!html) {
						throw "no html";
					}
					
					newContent.insertAdjacentHTML('afterbegin', html);
					newContent.dataset.loaded = true;
					
					lazyLoad(newContent);
					init(newContent);
				} catch {
					this.#loading = false;
					
					return;
				}
				
				this.#loading = false;
			}
			
			tabs.activeLink.classList.remove('active');
			tabs.activeContent.classList.remove('active');

			li.classList.add('active');
			newContent.classList.add('active');

			tabs.activeLink = li;
			tabs.activeContent = newContent;

			const link = li.querySelector('a');

			if (!link.href.endsWith('#')) {
				// console.log('history update', link.href);

				history.pushState({}, null, link.href);
			}
		});

		this.#elements.push(tabs);
	}
}

function init(container, fetchMethod = null) {
	return new Tabs(container, fetchMethod);
}

export default { init };
